export default "__VITE_ASSET__6DRYh9bm__"